import * as globals from '@wandb/weave/common/css/globals.styles';
import styled from 'styled-components';

import {THEME} from '../../weave/common/css/color.styles';

export const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const SectionTopHeader = styled.div`
  display: flex;
  justify-content: space-between;
  color: light-dark(var(--moon-800), var(--moon-200));
  font-family: 'Source Sans 3';
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  margin-bottom: 4px;
  align-items: center;
`;

/**
 * HTML sections are used to group thematically related content.
 * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/section#usage_notes
 * Sections should ideally contain a heading, although the use of a single header
 * per section is allowed.
 */
export const Section = styled.section<{
  noPadding?: boolean;
  transparentBackground?: boolean;
}>`
  position: relative;
  margin-bottom: 40px;
  background-color: ${p => (p.transparentBackground ? 'none' : THEME.bgSurface)};
  border-radius: 8px;
`;

export const SectionHeaderSubText = styled.span`
  font-size: calc(${globals.fontSizeStandard} * 0.875);
  color: light-dark(var(--moon-650), var(--moon-350));
  margin-left: calc(${globals.spu} * 1);
  position: relative;
  top: 2px;

  display: inline-flex;
  align-items: center;
`;

export const SectionHeaderActions = styled.div`
  height: 24px;
  display: flex;
  align-items: center;
`;
